import classnames from 'classnames';
import styles from './Button.module.scss';

/** `link`: drawn as a text link (no frame or fill), for a light action inline with text; it ignores `shape` and `prominent`. */
export type ButtonVariant = 'primary' | 'secondary' | 'link';
export type ButtonSize = 'small' | 'medium' | 'large';
export type ButtonShape = 'rectangle' | 'round';

const VARIANT_CLASSES: Record<ButtonVariant, string | undefined> = {
    primary: undefined,
    secondary: styles.secondary,
    link: styles.link,
};

const SIZE_CLASSES: Record<ButtonSize, string | undefined> = {
    small: styles.small,
    medium: styles.medium,
    large: styles.large,
};

const SHAPE_CLASSES: Record<ButtonShape, string | undefined> = {
    rectangle: styles.rectangle,
    round: styles.round,
};

/** The look a `Button` or `LinkButton` asks for. */
export interface ButtonLook {
    variant: ButtonVariant;
    size: ButtonSize;
    shape: ButtonShape;
    /** High visibility (a sign-in or call to action): roomy padding, where a normal button stays compact. */
    prominent: boolean;
}

/** The classes for a button's look, shared by `Button` and `LinkButton` so the two can't drift. */
export function resolveButtonClassName({ variant, size, shape, prominent }: ButtonLook, className?: string): string {
    const isFramed = variant !== 'link';
    return classnames(
        styles.button,
        VARIANT_CLASSES[variant],
        SIZE_CLASSES[size],
        isFramed && SHAPE_CLASSES[shape],
        isFramed && prominent && styles.prominent,
        className,
    );
}
